import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetBrands = () :
{ brands: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelValuePair[], AxiosError>('/marker/getBrands',
    (url) => fetcher(url));

  return {
    brands: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetBrands;
